var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocGenerico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.418,
    height: 151.39,
    viewBox: "0 0 136.418 151.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#7e8082;stroke-linecap:round;stroke-width:2px;}.c{fill:#f84b6b;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 136.418,
    height: 151.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7136 -99)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -7136, 99)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.995,0H112.423c5.566,0,5.995.511,5.995,6.177V127.213c0,5.667-.429,6.177-5.995,6.177H5.995C.429,133.39,0,132.88,0,127.213V6.177C0,.511.429,0,5.995,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 42.489,
    transform: "translate(-7108.804 156.54)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 82.618,
    transform: "translate(-7108.804 192.75)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 53.896,
    transform: "translate(-7080.083 126.132)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 42.489,
    transform: "translate(-7108.804 168.343)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 23.552,
    transform: "translate(-7049.738 137.934)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 42.489,
    transform: "translate(-7108.804 180.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 22.19,
    height: 15.136,
    rx: 1,
    transform: "translate(-7109.75 122.501)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocGenerico);
export default __webpack_public_path__ + "static/media/docGenerico.5ddd603573f25bd06f713039d23071f8.svg";
export { ForwardRef as ReactComponent };